let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ikYvP")).then(() => parcelRequire('520sz'));